(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const searchButton = event.target.closest('search-button .header-actions__action');
    const searchModal = document.getElementById('search-modal');
    const dialog = searchModal?.querySelector('dialog');

    if (!searchButton || !searchModal || typeof searchModal.showDialog !== 'function' || dialog?.open) return;

    event.preventDefault();
    searchModal.showDialog();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vf-header-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.vf-header-localization[open]').forEach((selector) => {
      if (!selector.contains(event.target)) selector.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.vf-header-localization[open]').forEach((selector) => {
      selector.removeAttribute('open');
      selector.querySelector('summary')?.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
